export const WHOLE_CURRENCIES = new Set(["COP", "CLP", "VES", "PYG", "IDR", "VND", "KRW", "JPY"]);

export const CURRENCY_LOCALES = {
  ARS: "es-AR", BOB: "es-BO", BRL: "pt-BR", CLP: "es-CL", COP: "es-CO",
  CRC: "es-CR", EUR: "it-IT", GBP: "en-GB", GTQ: "es-GT", HNL: "es-HN",
  MXN: "es-MX", NIO: "es-NI", PEN: "es-PE", PYG: "es-PY", USD: "en-US",
  UYU: "es-UY", VES: "es-VE",
};

export const normalizeCurrency = (currency) => String(currency || "COP").toUpperCase();
export const getCurrencyLocale = (currency) => CURRENCY_LOCALES[normalizeCurrency(currency)] || "en-US";

export const getCurrencyFractionDigits = (currency) => {
  const code = normalizeCurrency(currency);
  if (WHOLE_CURRENCIES.has(code)) return 0;
  try {
    return new Intl.NumberFormat(getCurrencyLocale(code), {
      style: "currency", currency: code,
    }).resolvedOptions().maximumFractionDigits;
  } catch {
    return 2;
  }
};

export const formatMoney = (amount, currency = "COP", { absolute = false, style = "currency" } = {}) => {
  const code = normalizeCurrency(currency);
  const digits = getCurrencyFractionDigits(code);
  const numericAmount = Number(amount || 0);
  return new Intl.NumberFormat(getCurrencyLocale(code), {
    style,
    ...(style === "currency" ? { currency: code } : {}),
    minimumFractionDigits: 0,
    maximumFractionDigits: digits,
  }).format(absolute ? Math.abs(numericAmount) : numericAmount);
};
